import Accordion from '@/common/components/Accordion'
import InfoField from '@/common/components/InfoField'
import { EquipmentModelLatestFipeDataAerodynamics } from '@/features/equipmentModels/types/equipmentModelLatestFipe'

interface FipeAerodynamicsAccordionProps {
  aerodynamicsData?: EquipmentModelLatestFipeDataAerodynamics
}

export default function FipeAerodynamicsAccordion({ aerodynamicsData }: FipeAerodynamicsAccordionProps) {
  return (
    <Accordion
      name="Aerodynamics"
      head="Aerodinâmica"
      defaultOpen
      body={
        <div className='flex items-center gap-1'>
          <InfoField 
            label="Área Frontal" 
            value={aerodynamicsData?.["Area Frontal"]} 
          />
          <InfoField 
            label="Área Frontal Corrigida" 
            value={aerodynamicsData?.["Area Frontal Corrigida"]} 
          />
          <InfoField 
            label="Coeficiente Arrasto" 
            value={aerodynamicsData?.["Coeficiente Arrasto"]} 
          />
        </div>
      }
    />
  )
}